import React from "react"

function FakeMovieDetails() {
    return (
        <section id="movie-details-section">
            <div id="movie-data-container">
                <div id='fake-detailed-movie-poster'/>
                <div id="movie-data">
                    <div id="fake-detailed-movie-title"/>
                    <div id="fake-overview"/>
                    <div id="fake-data">
                        <div id="fake-duration"/>
                        <div id="fake-year"/>
                    </div>
                    <div id="fake-movie-categories"/>
                </div>
            </div>
        </section>
    )
}

export {FakeMovieDetails}